import {
  Box as MuiBox,
  Typography as MuiTypography,
  LinearProgress,
} from "@mui/material";
import PropTypes from "prop-types";
import ContextualHelp from "../../../shared/UI/ContextualHelp";

const SidebarSectionHeader = ({ title, description, helpText, loading }) => {
  return (
    <MuiBox>
      <MuiBox
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
        }}
      >
        <MuiTypography variant="h3" sx={{ fontSize: "18px", mb: 0.5 }}>
          {title}
        </MuiTypography>

        {helpText && <ContextualHelp helpText={helpText} />}
      </MuiBox>
      {loading && <LinearProgress color="secondary" />}

      {description && (
        <MuiTypography variant="caption">{description}</MuiTypography>
      )}
    </MuiBox>
  );
};

SidebarSectionHeader.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  helpText: PropTypes.string,
  loading: PropTypes.bool,
};

export default SidebarSectionHeader;
